/// <amd-module name="Analytics/Shared/Visuals/Common/Components/LabelledContextualMenu" />
import * as React from "react";

import { IMenuItem, MenuButton } from "VSSUI/Menu";

export interface ILabelledContextualMenuProps {
    tooltipHostContent?: string;
    contextualMenuAriaLabel?: string;
    metricOptions?: { [key: number]: string };
    selectedMetricOption?: number;
    onMetricChange?: (metricOptionSelected: number) => void;
}

/** LabelledContextualMenu provides functionality of CommandBarButton with calling the onMetricChange with the key(of type number) provided.
 * LabelledContextualMenu accepts metricOptions in the { [key: number]: String } format.
 */
export class LabelledContextualMenu extends React.PureComponent<ILabelledContextualMenuProps> {
    public render(): JSX.Element {
        return (
            <div className={"labelledContextualMenu"}>
                <MenuButton
                    className={"labelledContextualMenu-options"}
                    text={this._getSelectedOptionText()}
                    ariaLabel={this.props.contextualMenuAriaLabel}
                    contextualMenuProps={{
                        menuProps: {
                            id: "labelledContextualMenu",
                            items: this._convertToContextualMenuItemArray(this.props.metricOptions || [])
                        },
                        onActivate: this._onMetricChanged
                    }}
                />
            </div>
        );
    }

    private _onMetricChanged = (item: IMenuItem, ev: React.MouseEvent<HTMLElement>) => {
        if (this.props.onMetricChange) {
            this.props.onMetricChange(Number(item.id));
        }
    };

    private _convertToContextualMenuItemArray(options: { [key: number]: string }): IMenuItem[] {
        return Object.keys(options).map((k: any) => ({ id: k, text: options[k], onActivate: this._onMetricChanged } as IMenuItem));
    }

    private _getSelectedOptionText() {
        if (this.props.metricOptions && typeof this.props.selectedMetricOption == "number") {
            return this.props.metricOptions[this.props.selectedMetricOption] || "";
        }
        return "";
    }
}
